import { render, staticRenderFns } from "./dataCustomer.vue?vue&type=template&id=3c870416&scoped=true&"
import script from "./dataCustomer.vue?vue&type=script&lang=js&"
export * from "./dataCustomer.vue?vue&type=script&lang=js&"
import style0 from "./dataCustomer.vue?vue&type=style&index=0&id=3c870416&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c870416",
  null
  
)

export default component.exports